import {Component, ElementRef, ViewChild} from '@angular/core';

import {AlertController, LoadingController, NavController, ToastController} from 'ionic-angular';
import { ModalController, ViewController,NavParams } from 'ionic-angular';



import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';
import { UserData } from '../../../providers/user-data';
import { UiData } from "../../../providers/ui-data";
import { JobDataService } from '../../../providers/job-data';

import { SearchPipe } from '../../../pipes/search/search';

import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import {RibSelect} from "../rib-select/rib-select";
import {CompanyAccessModal} from "../company-access/company-access";
import {DocumentSelectForm} from "../document-select/document-select";
import {Geolocation} from "@ionic-native/geolocation";

declare var google: any;

@Component({
    selector: 'page-documentscomplete',
    templateUrl: 'documents-complete.html'
})
export class DocumentsCompleteModal {


    id: any;
    data: any;

    user: any;

    loading: any = false;
    currently_loading: any = false;

    postulateData: any;
    postulateForm : FormGroup;

    submitAttempt: boolean = false;
    steps:any = 3;
    step:any = 1;

    countryList: any;

    constructor(
        public uiData: UiData,
        public viewCtrl: ViewController,
        public navParams: NavParams,
        public alertCtrl: AlertController,
        public nav: NavController,
        public userData: UserData,
        public navCtrl: NavController,
        public toastCtrl: ToastController,
        public formBuilder: FormBuilder,
        public modalCtrl: ModalController,
        private geolocation: Geolocation,
        public loadingCtrl: LoadingController,
    ) {

        this.postulateForm = this.formBuilder.group({
            secu: [null, [Validators.required, this.secuValidator.bind(this) ]],

            adr1: ['', [Validators.required,Validators.minLength(5)]],
            cp: ['', [Validators.required,Validators.pattern(this.uiData.getZipcodePattern()),Validators.minLength(4)]],
            ville: ['', [Validators.required,Validators.minLength(2)]],
            pays: [null, Validators.required],
            //vitale: [null, [Validators.required ]],
            last_visit: ['', [Validators.required]],
            rib_info: ['', [Validators.required]],
            identity: [null, [Validators.required ]],
            domicile: [null, [Validators.required ]],
        });

    }
    secuValidator(control: FormControl): {[s: string]: boolean} {
        if (control.value && control.value.length < 15) {
            return {invalidSecu: true};
        }
        if (control.value && control.value.length > 15) {
            return {invalidSecu: true};
        }
    }
    addRibInfo()
    {
        var that = this;
        let documentSelectModal = this.modalCtrl.create(RibSelect, { 'rib':that.postulateData.rib_info });
        documentSelectModal.onDidDismiss(data => {
            if(data && data.success){
                that.postulateData.rib_info = {'iban':data.iban};
            }
        });
        documentSelectModal.present();
    }
    changeRibInfo()
    {
        this.addRibInfo();
    }
    saveItem() {

    }
    ionViewDidLoad() {

        var that = this;
        that.id = that.navParams.data.id;
        that.data = this.userData.get('companiesAsking/'+that.id);


        this.postulateData = {
            secu: '',

            adr1 : '',
            adr2 : '',
            cp : '',
            ville : '',
            pays : 'FR',
            last_visit: '',

            vitale: '',
            identity: '',
            domicile: '',
            rib: '',
        };

        /*this.missionsData.load().subscribe((data: any) => {
            for(let i=0;i<data.length;i++){
                if(data[i].id === this.navParams.data.missionId)
                {
                    this.mission = data[i];
                }
            }
        });*/
        this.countryList = this.uiData.countryList();
        this.userData.load().subscribe(data => {
            that.user = data;

            if(that.user.identity)
            {
                if(that.user.identity.secu)    this.postulateData.secu = that.user.identity.secu;
                if(that.user.identity.last_visit)    this.postulateData.last_visit = that.user.identity.last_visit;
            }
            if(that.postulateData.last_visit && that.postulateData.last_visit=="2000-01-01")
            {
                that.postulateData.no_visit = true;
            }
            if(that.user.address)
            {
                if(that.user.address.adr1)    this.postulateData.adr1 = that.user.address.adr1;
                if(that.user.address.adr2)    this.postulateData.adr2 = that.user.address.adr2;
                if(that.user.address.cp)    this.postulateData.cp = that.user.address.cp;
                if(that.user.address.ville)    this.postulateData.ville = that.user.address.ville;
                if(that.user.address.pays)    this.postulateData.pays = that.user.address.pays;
            }
            if(that.user.documents)
            {
                if(that.user.documents.vitale)
                    this.postulateData.vitale = that.user.documents.vitale.url;
                if(that.user.documents.identity)
                    this.postulateData.identity = that.user.documents.identity.url;
                if(that.user.documents.domicile)
                    this.postulateData.domicile = that.user.documents.domicile.url;
                if(that.user.documents.rib)
                    this.postulateData.rib = that.user.documents.rib.url;
                if(that.user.documents.rib_info)
                    this.postulateData.rib_info = that.user.documents.rib_info;
            }

        });

    }
    savePostulate() {

        this.submitAttempt=true;
        var that = this;

        if(that.postulateData.no_visit)that.postulateData.last_visit="2000-01-01";

        if(that.postulateForm.valid)
        {
            let prompt = this.alertCtrl.create({
                title: 'Confirmation des informations',
                message: that.uiData.getDataValidationWarning(),
                buttons: [
                    {
                        text: 'Oui',
                        handler: data => {
                            that.userData.update('identity','secu',that.postulateData.secu);
                            that.userData.update('identity','last_visit',that.postulateData.last_visit);
                            that.userData.update('address','adr1',that.postulateData.adr1);
                            that.userData.update('address','adr2',that.postulateData.adr2);
                            that.userData.update('address','cp',that.postulateData.cp);
                            that.userData.update('address','ville',that.postulateData.ville);
                            that.userData.update('address','pays',that.postulateData.pays);
                            that.userData.update('documents','rib_info',that.postulateData.rib_info);
                            that.submitAttempt = false;
                            that.navCtrl.pop();
                            that.navCtrl.push(CompanyAccessModal,{'id':that.id});
                        }
                    },
                    {
                        text: 'Annuler',
                        handler: data => {

                        }
                    }
                ]
            });
            prompt.present();
        }
        else
        {

        }

    }
    chooseDocument(mode)
    {
        let documentSelectModal = this.modalCtrl.create(DocumentSelectForm, { document_type: mode });
        documentSelectModal.onDidDismiss(data => {
            if(data && data.document_type)
            {
                this.postulateData[data.document_type] = data.url;
            }
            else
            {

            }
        });
        documentSelectModal.present();
    }
    addVitale()
    {
        this.chooseDocument('vitale') ;
    }
    addDomicile()
    {
        this.chooseDocument('domicile') ;
    }
    addIdentity()
    {
        this.chooseDocument('identity') ;
    }
    addRib()
    {
        this.chooseDocument('rib') ;
    }
    accept(){
        this.data.state="accepted";
        this.userData.set('companiesAsking/'+this.id,this.data);
        let toast = this.toastCtrl.create({
            showCloseButton: true,
            cssClass: 'profile-bg',
            message: 'Votre choix a été enregistré, merci.',
            duration: 3000,
            position: 'bottom'
        });
        toast.present();
        this.navCtrl.pop();
    }
    refuse(){
        this.data.state="refused";
        this.userData.set('companiesAsking/'+this.id,this.data);
        let toast = this.toastCtrl.create({
            showCloseButton: true,
            cssClass: 'profile-bg',
            message: 'Votre choix a été enregistré, merci.',
            duration: 3000,
            position: 'bottom'
        });
        toast.present();
        this.navCtrl.pop();
    }
    chooseFavAddress(address) {
        this.data = {
            'mode': 'favorite',
            'data': address
        };
        this.viewCtrl.dismiss(this.data);
    }
    processGooglePlaceData(data) {
        this.data = data;
    }
    dismiss() {
        this.viewCtrl.dismiss(this.data);
    }
    setLoading(state,msg=""){
        if(msg == "")msg = 'Chargement des missions ...';
        if(state)
        {
            this.currently_loading = true;
            this.loading = this.loadingCtrl.create({
                content: msg
            });
            this.loading.present();
        }
        else if(this.loading){
            this.currently_loading = false;
            this.loading.dismiss();
        }
    }
    geoLocate()
    {
        var that = this;
        this.setLoading(true,'Géolocalisation en cours ...');
        this.geolocation.getCurrentPosition().then((resp) => {
            var geocoder = new google.maps.Geocoder;
            var latlng = {lat: resp.coords.latitude, lng: resp.coords.longitude};
            var that = this;
            geocoder.geocode({'location': latlng}, function(results, status) {

                if (status === 'OK') {
                    if (results[0]) {
                        for(let i=0;i<results[0].address_components.length;i++)
                        {
                            let component = results[0].address_components[i];
                            if(component.types.includes("route"))
                            {
                                that.postulateData.adr1 = component.long_name;
                            }
                            if(component.types.includes("locality"))
                            {
                                that.postulateData.ville = component.long_name;
                            }
                            if(component.types.includes("postal_code"))
                            {
                                that.postulateData.cp = component.long_name;
                            }
                            if(component.types.includes("country"))
                            {
                                that.postulateData.pays = component.short_name;
                            }
                        }
                    } else {
                    }
                } else {
                }
                that.setLoading(false);
            });
        }).catch((error) => {
            const toast = this.toastCtrl.create({
                message: 'La géolocalisation a échoué. ' +
                'Il est possible que vous ayez refusé d\'être géolocalisé ou que les paramètres de votre appareil ne le permette pas.' +
                'N\'hésitez pas à choisir le mode de recherche par adresse.',
                showCloseButton: true,
                cssClass: 'danger',
                closeButtonText: 'Ok',
                dismissOnPageChange: true,
                duration:10000
            });
            toast.present();
            //this.searchFilters.location.mode = 'address';
            this.setLoading(false);
        });
    }

}


// WEBPACK FOOTER //
// ./src/pages/utils/documents-complete/documents-complete.ts